import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=1e2d8c2a&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"
import style0 from "./Tip.vue?vue&type=style&index=0&id=1e2d8c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d8c2a",
  null
  
)

export default component.exports